import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export const FormLayout = styled.div({
  display: 'grid',
  rowGap: spacing.bigx3,
  boxSizing: 'border-box',
  gridTemplateRows: 'min-content 1fr min-content',
  minHeight: '100%',
  padding: '2.2rem 2rem 2rem',
  backgroundColor: colors.white,
  color: colors.black,
  fontFamily: font.family.primary,

  '> footer': {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
})

export const DocumentBodyStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
})
